import StatsWidgets from '@rio-cloud/rio-uikit/StatsWidgets';
import StatsWidget from '@rio-cloud/rio-uikit/StatsWidget';
import styles from './ActiveMaintenanceContractCard.module.css'

interface ActiveMaintenanceContractCardProps {
    score: number | undefined;
    maxScore: number | undefined;
    status: string | undefined;
    contractType: string | undefined;
}

export function ActiveMaintenanceContractCard({ score = 0, maxScore = 0, status, contractType }: ActiveMaintenanceContractCardProps) {


    const setMessage = () => {
        if (status === 'ATIVO') {
            return (
                <div className='margin-top-20'>
                    Tudo certo! <b>Contrato ativo</b> e pontuação garantida.
                </div>
            )
        } else if (status === 'VENCENDO') {
            return (
                <div className='margin-top-20'>
                    <b>Atenção:</b> seu contrato vence em breve. <b>Renove</b> para não perder pontos.
                </div>
            )
        } else {
            return (
                <div className='margin-top-20'>
                    Nenhum contrato ativo. <b>Comece agora</b> para pontuar.
                </div>
            )
        }
    }

    return (
        <StatsWidgets>
            <StatsWidget className='shadow-default' style={{ height: 250 }}>
                <StatsWidget.Header>Contrato de Manutenção Ativo {contractType ? ` - ${contractType}` : ''}</StatsWidget.Header>
                <StatsWidget.Body className='padding-20'>
                    <div className={styles['score-container']}>
                        <div className='text-center'>
                            <div>
                                {score === maxScore ? (
                                    <div style={{ fontSize: 40 }}>
                                        <span className={styles["current-score"]}>{score}</span>
                                    </div>
                                ) : (
                                    <div style={{ fontSize: 40 }}>
                                        <span className={styles["current-score"]}>{score}</span>
                                        <span className={styles["total-score"]}>/ {maxScore}</span>
                                    </div>
                                )}
                                {score === maxScore ? (
                                    <div className='margin-top-10'>
                                        <div className="label text-size-12 label-success">
                                            Pontuação Máxima! <span className='rioglyph rioglyph-trophy'></span>
                                        </div>
                                    </div>
                                ) : (
                                    null
                                )}
                            </div>
                        </div>
                        <div>
                            {setMessage()}
                        </div>
                    </div>
                </StatsWidget.Body>
            </StatsWidget>
        </StatsWidgets>
    );
}